import React, { useState } from "react";
import { Row, Col, FormFeedback, Input, Label, Card, CardHeader, Table, CardBody, Button } from 'reactstrap';
import axios from "axios";
import { ReactComponent as AnalyticsIcon3 } from '../Res/CDR/datagram_3.svg';
import { ReactComponent as AnalyticsIcon2 } from '../Res/CDR/datagram_2.svg';
import Pagination from 'rc-pagination';
import SetLimitEntries from '../components/SetLimitEntries';
import { ENG_LOCALE } from '../lib/constants';
import Spinner from './Spinner/Spinner.js';
import { toast } from 'react-toastify';
import CustomModal from "./CustomModal";
import { useUnifiedMutate } from "../hooks/useUnifiedMutate.js";

const NUMBER_REGEX = /^\d{10}$/;

function isDateValid(date){
    let currentTime = new Date().getTime();

    let selectedTime = date.getTime();

    let differenceInHours = Math.abs((currentTime - selectedTime) / (1000 * 60 *60));

    return differenceInHours > 36
}

function format_value(value){
    if(value === 0 || value === '0'){
        return ''
    }

    return value
}

function PcapLookup() {
    const token = localStorage.getItem('jwtToken') || null;
    const initialState = {
        limit: 10,
        page: 1,
        totalDocs: 0,
        start: 0
    }

    const [paginationOptions, setPaginationOptions] = useState(initialState);
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [TimeTo, setTimeTo] = useState(null);
    const [TimeFrom, setTimeFrom] = useState(null);
    const [caller, setCaller] = useState(null);
    const [called, setCalled] = useState(null);
    const [cdrData, setCdrData] = useState([]);
    const [svgModelOpen, setSvgModelOpen] = useState(false);
    const [svgData, setSvgData] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const {
        mutate: callCdrLogsApi,
        isLoading: isRetrievingCdrLogs,
    } = useUnifiedMutate();

    const fetchCdrLogs = async (paginationOptions) => {
        try{
            if (isRetrievingCdrLogs) {
                return;
            }
    
            setIsLoading(true)
            const endpoint = 'numbers/cdr/logs';
            const method = 'PUT';
    
            let {result, totalRecords} = await callCdrLogsApi({
                isMyEpik: true,
                endpoint,
                method,
                body: paginationOptions,
            });
    
            if (!result) {
                setIsLoading(false)
                toast.error(`Error while retrieving call logs`)
                return
            }

            if (!result?.length) {
                setIsLoading(false)
                toast.warn(`No call logs`)
                return
            }
    
            setPaginationOptions((prev) => ({ ...prev, ...paginationOptions, totalDocs: totalRecords || result.length}))
            setCdrData(result);
            setIsLoading(false)
        }catch(error){
            setIsLoading(false)
            toast.error(`Error while retrieving call logs`)
            return
        }
    };

    const fetchCdrCallFlowSVG = async (sensorID, dc) => {
        try {
            setIsLoading(true)

            let {data} = await axios.get(`${process.env.REACT_APP_MYEPIK_URL}/v2/numbers/call-logs/svg/${sensorID}?dc=${dc}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    }
                }
            );


            if (!data) {
                setIsLoading(false);
                toast.error(`Error while retrieving call flow diagram`);
                return
            }

            setIsLoading(false);
            setSvgData(data);
            setSvgModelOpen(true);
        } catch (error) {
            setIsLoading(false)
            toast.error(`Error while retrieving call flow diagram`)
            return
        }
    };

    async function onSubmit(options = initialState) {
        let dateTimeFrom = dateFrom ? new Date(`${dateFrom}T${TimeFrom || "00:00"}`) : '';
        let dateTimeTo = dateTo ? new Date(`${dateTo}T${TimeTo || "00:15"}`) : new Date();

        if(isDateValid(dateTimeFrom)){
            toast.warn('Only records from the past 36 hours are available for search')
            return
        }

        if(!caller && !called){
            toast.warn('Need caller or called number')
            return
        }

        if(caller && !caller.match(NUMBER_REGEX)){
            toast.warn('Please enter 10 digits, for caller number')
            return
        }

        if(called && !called.match(NUMBER_REGEX)){
            toast.warn('Please enter 10 digits, for called number')
            return
        }

        
        let filter = {
            callDateFrom: dateTimeFrom.toISOString().split('.')[0],
            callDateTo: dateTimeTo.toISOString().split('.')[0],
            callerID: caller || '',
            calledID: called || '',
            limit: options.limit || 10,
            page: options.page || 1,
            totalDocs: options.totalDocs,
            start: options.page === 1 ? 0 : options.start
        }

        console.log(filter)
        await fetchCdrLogs(filter)
    }

    const handlePagination = async (currPage, limit) => {
        let start = paginationOptions.limit;
        if(currPage > paginationOptions?.page){
            start = paginationOptions.limit + paginationOptions.start
        }

        if(currPage < paginationOptions?.page){
            start = paginationOptions.limit - paginationOptions.start
        }

        await onSubmit({ ...paginationOptions, page: currPage, start: start, limit: limit })
    }

    const handleLimit = async (value) => {
        await onSubmit({ ...paginationOptions, limit: value })
    }

    async function downloadPcapFile(callId, dc) {
        try {
            let response = await axios.get(`${process.env.REACT_APP_MYEPIK_URL}/v2/numbers/call-logs/pcap/${callId}?dc=${dc}`,
                {
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        'Content-Type': 'application/octet-stream',

                    },
                    responseType: 'arraybuffer',
                }
            );

            if (response.data) {
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: 'application/octet-stream',
                    })
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Analytics-CDR.pcap');
                document.body.appendChild(link);
                link.click();
                link.remove();
            } else {
                toast.error('Unable to find PCAP File.')
            }
        } catch (error) {
            console.log(`Error while retrieving pcap : ${error}`)
            return
        }
    }

    return (
        <div>
            <CustomModal
                isOpen={svgModelOpen}
                onCancel={() => setSvgModelOpen(false)}
                medium
                close
                onClick={() => { }}
            >
                {/* <img src={analyticsImage} alt="Analytics" /> */}
                <div dangerouslySetInnerHTML={{ __html: svgData }} className='cdr-callflow-svg' />
            </CustomModal>
            <Row className="px-4">
                <Col className="p-1" xs="3">
                    <Card className="p-0">
                        <CardHeader className="p-1" style={{ background: '#3b5aa9', color: 'white' }} >
                            Date Range
                        </CardHeader>
                        <CardBody className="p-2">
                            <Row className="row g-3 align-items-end p-2">
                                <Col sm={2} className="p-1">
                                    <Label
                                        for="from-date"
                                        className="form-label-static p-0"
                                    >
                                        From:
                                    </Label>
                                </Col>
                                <Col className="p-1" sm={7}>
                                    <Input
                                        id="from-date"
                                        name="from-date"
                                        placeholder="2024-06-13"
                                        type="date"
                                        value={dateFrom}
                                        onChange={(e) => setDateFrom(e.currentTarget.value)}
                                    />
                                </Col>
                                <Col className="p-1" sm={3}>
                                    <Input
                                        id="from-time"
                                        name="from-time"
                                        type="time"
                                        value={TimeFrom}
                                        onChange={(e) => setTimeFrom(e.currentTarget.value)}
                                    />
                                </Col>
                            </Row>
                            <Row className="row g-3 align-items-end p-2">
                                <Col className="p-1" sm={2}>
                                    <Label
                                        for="to-date"
                                        className="form-label-static"
                                    >
                                        To:
                                    </Label>
                                </Col>
                                <Col className="p-1" sm={7}>
                                    <Input
                                        id="to-date"
                                        name="to-date"
                                        placeholder="2024-06-13"
                                        type="date"
                                        value={dateTo}
                                        onChange={(e) => setDateTo(e.currentTarget.value)}
                                    />
                                    <FormFeedback>

                                    </FormFeedback>
                                </Col>
                                <Col className="p-1" sm={3}>
                                    <Input
                                        id="to-time"
                                        name="to-time"
                                        type="time"
                                        value={TimeTo}
                                        onChange={(e) => setTimeTo(e.currentTarget.value)}
                                    />

                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs="2" className="p-1">
                    <Card className="p-0">
                        <CardHeader className="p-1" style={{ background: '#3b5aa9', color: 'white' }}>
                            Filters
                        </CardHeader>
                        <CardBody className="p-2">
                            <Row className="row g-3 align-items-end p-2">
                                <Col sm={5} className="p-1">
                                    <Label
                                        for="caller-number"
                                        className="form-label-static"
                                    >
                                        Caller Number:
                                    </Label>
                                </Col>
                                <Col sm={7} className="p-1">
                                    <Input
                                        id="caller-number"
                                        name="caller-number"
                                        type="text"
                                        value={caller}
                                        placeholder={'1115550000'}
                                        onChange={(e) => setCaller(e.currentTarget.value)}
                                    />
                                </Col>
                            </Row>
                            <Row className="row g-3 align-items-end p-2">
                                <Col sm={5} className="p-1">
                                    <Label
                                        for="called-number"
                                        className="form-label-static"
                                    >
                                        Called Number:
                                    </Label>
                                </Col>
                                <Col sm={7} className="p-1">
                                    <Input
                                        id="called-number"
                                        name="called-number"
                                        type="text"
                                        value={called}
                                        placeholder={'1115550000'}
                                        onChange={(e) => setCalled(e.currentTarget.value)}
                                    />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Col>
                <Col xs="2" className="p-1 align-self-end">
                    <Button type="button" onClick={onSubmit} style={{ width: '50%' }}>
                        Search
                    </Button>
                </Col>
            </Row>
            {isLoading ? <Spinner /> : (
                <>
                    <Row>
                        <Table hover className="provisionList">
                            <thead>
                                <tr>
                                    <th>
                                        Date/Time
                                    </th>
                                    <th>
                                        Duration
                                    </th>
                                    <th>
                                        Caller Number
                                    </th>
                                    <th>
                                        Called Number
                                    </th>
                                    <th>
                                        Last Response
                                    </th>
                                    <th>
                                        Caller src MOS
                                    </th>
                                    <th>
                                        Called src MOS
                                    </th>
                                    <th>
                                        Tools
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    !cdrData?.length ? <></> : (cdrData.map((data) => {
                                        let { a_mos_f1, a_mos_f2, a_mos_adapt, a_mos_silence, a_mos_silence_min, a_rtcp_maxjitter, a_rtcp_avgjitter, a_rtcp_maxfr, a_rtcp_avgfr, a_rtp_ptime, a_d50, a_d70, a_d90, a_d120, a_d150, a_d200, a_d300 } = data
                                        let { b_mos_f1, b_mos_f2, b_mos_adapt, b_mos_silence, b_mos_silence_min, b_rtcp_maxjitter, b_rtcp_avgjitter, b_rtcp_maxfr, b_rtcp_avgfr, b_rtp_ptime, b_d50, b_d70, b_d90, b_d120, b_d150, b_d200, b_d300 } = data
                                        let { a_sl1, a_sl2, a_sl3, a_sl4, a_sl5, a_sl6, a_sl7, a_sl8, a_sl9, a_sl10 } = data
                                        let { b_sl1, b_sl2, b_sl3, b_sl4, b_sl5, b_sl6, b_sl7, b_sl8, b_sl9, b_sl10 } = data

                                        let isAllNullJitterA = [a_d50, a_d70, a_d90, a_d120, a_d150, a_d200, a_d300].every(elem => elem === null || elem === 0 || elem === '0')
                                        let isAllNullPacketLossA = [a_sl1, a_sl2, a_sl3, a_sl4, a_sl5, a_sl6, a_sl7, a_sl8, a_sl9, a_sl10].every(elem => elem === null || elem === 0 || elem === '0')

                                        let jitterA = isAllNullJitterA ? `no jitter` : `${a_d50 || ''}:${a_d70 || ''}:${a_d90 || ''}:${a_d120 || ''}:${a_d150 || ''}:${a_d200 || ''}:${a_d300 || ''}`
                                        let packetLossA = isAllNullPacketLossA ? `no packet loss` : `${a_sl1 || ''}:${a_sl2 || ''}:${a_sl3 || ''}:${a_sl4 || ''}:${a_sl5 || ''}:${a_sl6 || ''}:${a_sl7 || ''}:${a_sl8 || ''}:${a_sl9 || ''}:${a_sl10 || ''}`

                                        let jvalueA = a_rtcp_maxjitter === null && a_rtcp_avgjitter === null ? '' : `J:${a_rtcp_maxjitter}/${a_rtcp_avgjitter} |`
                                        let plvalueA = a_rtcp_maxfr === null && a_rtcp_avgfr === null ? '' : `L:${a_rtcp_maxfr}/${a_rtcp_avgfr} |`

                                        let isAllNullJitterB = [b_d50, b_d70, b_d90, b_d120, b_d150, b_d200, b_d300].every(elem => elem === null || elem === 0 || elem === '0')
                                        let isAllNullPacketLossB = [b_sl1, b_sl2, b_sl3, b_sl4, b_sl5, b_sl6, b_sl7, b_sl8, b_sl9, b_sl10].every(elem => elem === null || elem === 0 || elem === '0')

                                        let jitterB = isAllNullJitterB ? `no jitter` : `${b_d50 || ''}:${b_d70 || ''}:${b_d90 || ''}:${b_d120 || ''}:${b_d150 || ''}:${b_d200 || ''}:${b_d300 || ''}`
                                        let packetLossB = isAllNullPacketLossB ? `no packet loss` : `${b_sl1 || ''}:${b_sl2 || ''}:${b_sl3 || ''}:${b_sl4 || ''}:${b_sl5 || ''}:${b_sl6 || ''}:${b_sl7 || ''}:${b_sl8 || ''}:${b_sl9 || ''}:${b_sl10 || ''}`

                                        let jvalueB = b_rtcp_maxjitter === null && b_rtcp_avgjitter === null ? '' : `J:${b_rtcp_maxjitter}/${b_rtcp_avgjitter} |`
                                        let plvalueB = b_rtcp_maxfr === null && b_rtcp_avgfr === null ? '' : `L:${b_rtcp_maxfr}/${b_rtcp_avgfr} |`

                                        return (
                                            <tr key={data.ID}>
                                                <td>
                                                    {data?.calldate || ''}
                                                </td>
                                                <td>
                                                    {data?.duration || ''}
                                                </td>
                                                <td>
                                                    {data?.caller || ''}
                                                </td>
                                                <td>
                                                    {data?.called || ''}
                                                </td>
                                                <td>
                                                    <span dangerouslySetInnerHTML={{ __html: data?.lastresponse || "" }} />
                                                </td>
                                                <td>
                                                    {`${a_mos_f1 || ''}|${a_mos_f2 || ''}|${a_mos_adapt || ''}|${a_mos_silence || ''}|${a_mos_silence_min || ''}`}<br></br>
                                                    {`${jvalueA} ${jitterA}`}<br></br>
                                                    {`${plvalueA} ${packetLossA}`}<br></br>
                                                    {`ptime: ${a_rtp_ptime}`}
                                                </td>
                                                <td>
                                                    {`${b_mos_f1 || ''}|${b_mos_f2 || ''}|${b_mos_adapt || ''}|${b_mos_silence || ''}|${b_mos_silence_min || ''}`}<br></br>
                                                    {`${jvalueB} ${jitterB}`}<br></br>
                                                    {`${plvalueB} ${packetLossB}`}<br></br>
                                                    {`ptime: ${b_rtp_ptime}`}
                                                </td>
                                                <td className='d-flex justify-content-center' style={{ width: '100%' }}>
                                                    <AnalyticsIcon2
                                                        width={40}
                                                        height={40}
                                                        onClick={() => fetchCdrCallFlowSVG(data.ID, data.dc)}
                                                        className='cursor-pointer analytics-icon-datagram'
                                                        id={`call-flow-svg`}
                                                    />
                                                    <AnalyticsIcon3
                                                        width={40}
                                                        height={40}
                                                        onClick={() => downloadPcapFile(data.ID, data.dc)}
                                                        className='cursor-pointer analytics-icon'
                                                        id={`pcap-download-file`}
                                                    />
                                                </td>
                                            </tr>
                                        )
                                    })
                                    )}
                            </tbody>
                        </Table>
                    </Row>
                    {cdrData && cdrData.length ? (<Row className="justify-content-md-center">
                        <SetLimitEntries value={paginationOptions?.limit || 10} selectOptions={[10, 25, 50, 100]} onChange={handleLimit} />
                        <Pagination
                            locale={ENG_LOCALE}
                            className="pagination-container"
                            onChange={handlePagination}
                            current={paginationOptions.page}
                            total={paginationOptions.totalDocs || 0}
                            pageSize={parseInt(paginationOptions.limit, 10)}
                            showLessItems
                            showTotal={(total, range) => `${range[0]} - ${range[1] || 0} of ${total} items`}
                        />
                    </Row>) : <></>}

                </>
            )}
        </div>
    )
}

export default PcapLookup;
